import { environment } from "../../../environments/environment";

export abstract class BaseLinkAPI {
  public static API_HOST = environment.baseUrl;
  public static API_V1 = 'api/v1/g/';
}